import classes from "./FieldDescription.module.css";
import TickIcon from "../../img/tick-icon.svg";
import SEO from "../../seo/SEO";

export default function FieldDescription({ field }) {
  return (
    <div className={classes["field-description"]}>
      <SEO title={field.fieldTitle} description={field.fieldDescription} />
      <h2 className={classes["field-title"]}>{field.fieldName}</h2>
      <ul className={classes["field-list"]}>
        {field.fieldList.map((item) => (
          <li className={classes["field-list-item"]} key={item}>
            <img src={TickIcon} alt="Tick Icon" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
